import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import MobileBottomNav from "./components/MobileBottomNav";
import { usePageTracking } from "./utils/analytics";
import LandingPage from "./pages/LandingPage";
import AuthPage from "./pages/AuthPage";
import Dashboard from "./pages/Dashboard";
import JobSearch from "./pages/JobSearch";
import JobDetail from "./pages/JobDetail";
import ApplicationTracker from "./pages/ApplicationTracker";
import CommunityGroups from "./pages/CommunityGroups";
import ResumeBuilder from "./pages/ResumeBuilder";
import Membership from "./pages/Membership";
import Profile from "./pages/Profile";
import BusinessPortal from "./pages/BusinessPortal";
import PaymentSuccess from "./pages/PaymentSuccess";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import AdminDashboard from "./pages/AdminDashboard";
import EquipmentResources from "./pages/EquipmentResources";
import Support from "./pages/Support";
import HiringEvents from "./pages/HiringEvents";
import WFHPlatforms from "./pages/WFHPlatforms";
import Referrals from "./pages/Referrals";
import WFHTools from "./pages/WFHTools";
import SavedJobs from "./pages/SavedJobs";
import PracticeInterview from "./pages/PracticeInterview";
import Webinars from "./pages/Webinars";
import HelpHub from "./pages/HelpHub";
import Blog from "./pages/Blog";
import SalaryCalculator from "./pages/SalaryCalculator";
import JobAlerts from "./pages/JobAlerts";
import TermsOfService from "./pages/TermsOfService";
import PrivacyPolicy from "./pages/PrivacyPolicy";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen bg-[#FDFBF7] flex items-center justify-center">
      <div className="text-[#047857] animate-pulse-soft" style={{fontFamily:'Outfit'}}>Loading...</div>
    </div>
  );
  if (!user) return <Navigate to="/auth" replace />;
  return children;
}

function AppRoutes() {
  const { user, loading } = useAuth();
  usePageTracking();

  if (loading) return (
    <div className="min-h-screen bg-[#FDFBF7] flex items-center justify-center">
      <div className="text-[#047857] animate-pulse-soft" style={{fontFamily:'Outfit'}}>Loading...</div>
    </div>
  );

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/auth" element={user ? <Navigate to="/dashboard" replace /> : <AuthPage />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/jobs" element={<JobSearch />} />
      <Route path="/jobs/:jobId" element={<JobDetail />} />
      <Route path="/applications" element={<ProtectedRoute><ApplicationTracker /></ProtectedRoute>} />
      <Route path="/community" element={<CommunityGroups />} />
      <Route path="/resume-builder" element={<ProtectedRoute><ResumeBuilder /></ProtectedRoute>} />
      <Route path="/membership" element={<Membership />} />
      <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
      <Route path="/business" element={<ProtectedRoute><BusinessPortal /></ProtectedRoute>} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
      <Route path="/equipment" element={<EquipmentResources />} />
      <Route path="/support" element={<Support />} />
      <Route path="/hiring-events" element={<HiringEvents />} />
      <Route path="/hiring-events/:eventId" element={<HiringEvents />} />
      <Route path="/platforms" element={<WFHPlatforms />} />
      <Route path="/referrals" element={<ProtectedRoute><Referrals /></ProtectedRoute>} />
      <Route path="/tools" element={<WFHTools />} />
      <Route path="/saved-jobs" element={<ProtectedRoute><SavedJobs /></ProtectedRoute>} />
      <Route path="/practice-interview" element={<ProtectedRoute><PracticeInterview /></ProtectedRoute>} />
      <Route path="/webinars" element={<Webinars />} />
      <Route path="/help-hub" element={<HelpHub />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/salary-calculator" element={<SalaryCalculator />} />
      <Route path="/job-alerts" element={<JobAlerts />} />
      <Route path="/terms" element={<TermsOfService />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <AppRoutes />
          <MobileBottomNav />
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
